"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const SearchContextType_1 = require("./SearchContextType");
const Search_1 = __importDefault(require("./Search"));
const React = __importStar(require("react"));
const ConnectedSearch = (props) => {
    const [searched, setSearched] = (0, react_1.useState)(false);
    const { state, update, search, clearSearchTerm } = (0, react_1.useContext)(SearchContextType_1.SearchContext);
    const query = state.query;
    const handleQueryChange = (e) => {
        update((0, SearchContextType_1.queryUpdater)(e.value));
        setSearched(false);
    };
    const handleClear = () => {
        clearSearchTerm((0, SearchContextType_1.queryUpdater)(''));
    };
    const handleSearch = () => {
        if (!searched) {
            search();
            setSearched(true);
        }
    };
    return (React.createElement(Search_1.default, { query: query, handleClear: handleClear, handleSearch: handleSearch, handleQueryChange: handleQueryChange, placeholder: props.placeholder }));
};
exports.default = ConnectedSearch;
